import ReactDocViewer, { DocViewerRenderers } from "@cyntler/react-doc-viewer";
import { DocViewerFileFragment } from "gql/graphql";
import { useDocumentPreview } from "@/shared/form/button/document-button/model/use-document-preview";

export function DocViewer({ file }: { file: DocViewerFileFragment }) {
  const { uri } = useDocumentPreview(file);

  if (!uri) return null;

  return (
    <ReactDocViewer
      documents={[{ uri }]}
      pluginRenderers={DocViewerRenderers}
      config={{
        header: {
          disableHeader: true,
        },
        pdfVerticalScrollByDefault: true,
        noRenderer: {
          overrideComponent: () => null,
        },
      }}
    />
  );
}
